import { createContext, useState } from "react";
import type { IRegisterContextData, IRegisterProviderProps } from "./types";
import { createRegisterUtils } from "./utils";
import Loading from "../../components/Shared/Loading";

export const RegisterContext = createContext<IRegisterContextData | null>(null);

export const RegisterProvider = ({ children }: IRegisterProviderProps) => {
  const [isLoading, _setIsLoading] = useState(false);

  const contextValue: IRegisterContextData = {
    ...createRegisterUtils(),
  };

  return (
    <RegisterContext.Provider value={contextValue}>
      {isLoading && <Loading />}
      {children}
    </RegisterContext.Provider>
  );
};
